import { useState } from 'react';
import { useApi, googleAuthApiRef } from '@backstage/core-plugin-api';
import { Button, Typography, Box } from '@material-ui/core';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

const CMS_BASE = 'https://cms-lemon.luisabwk.com.br';

export function CmsWidget() {
  const googleAuth = useApi(googleAuthApiRef);
  const [loading, setLoading] = useState(false);

  const handleOpen = async () => {
    setLoading(true);
    try {
      const idToken = await googleAuth.getIdToken();
      window.open(
        `${CMS_BASE}/api/auth/google?token=${encodeURIComponent(idToken)}&redirect=/admin`,
        '_blank',
        'noopener,noreferrer',
      );
    } catch {
      window.open(`${CMS_BASE}/admin`, '_blank', 'noopener,noreferrer');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box p={1}>
      <Box mb={1}>
        <Typography variant="body2" color="textSecondary">
          Acesse o CMS de campanhas com o mesmo login do portal.
        </Typography>
      </Box>
      <Button
        variant="contained"
        color="primary"
        size="small"
        onClick={handleOpen}
        disabled={loading}
        startIcon={<OpenInNewIcon />}
      >
        {loading ? 'Abrindo…' : 'Abrir CMS'}
      </Button>
    </Box>
  );
}
